var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29206 0.482166C2.75024 -0.675366 0.5 0.382083 0.5 2.26415V17.7359C0.5 19.6179 2.75025 20.6754 4.29206 19.5178L14.5961 11.782C15.8013 10.8772 15.8013 9.12283 14.5961 8.21802L4.29206 0.482166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconWhite);
export default __webpack_public_path__ + "static/media/playIconWhite.1a8a78eca05a8d81b15a666330708e47.svg";
export { ForwardRef as ReactComponent };